import { Box, Pagination, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import ApiClient from '../../backend/ApiClient'
import { IPagination } from '../../definitions/Common'
import { ICounterparty } from '../../definitions/Providers'
import { changeRoute } from '../../store/slices/SessionSlice'
import RouteHeader from '../controls/RouteHeader'
import SmartCard from '../controls/cards/SmartCard'
import StaleObserver from '../controls/stale/StaleObserver'
import SmartTable from '../controls/table/SmartTable'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import Tile from '../layout/Tile'
import { SmartTableUtilities } from '../controls/table'
import Helper from '../../helpers/Helper'

export default function Network() {
    const dispatch = useDispatch()
    const [pagination, setPagination] = useState<IPagination>({ page: 0, batch: 20 })

    const { status, response } = useQuery({
        queryKey: buildQueryKey('Counterparties-network'),
        queryFn: async () => await ApiClient.getAllCounterparties(),
        cache: true
    })

    const isLoading = status === 'loading'
    const filterCounterparties = !Helper.hasVal(response) ? [] : response?.filter(x => x.contracts?.length > 0 || x.providers?.length > 0)
    const numberCounterpartiesGroups = filterCounterparties?.length ?? 0

    const renderSubContent = (counterparty: ICounterparty) => {
        if (!Helper.hasVal(counterparty)) return null

        return (
            <Tile.Row key={counterparty?.id} flex={1} style={{ maxHeight: 300 }}>
                <Tile.Column style={{ margin: 10 }}>
                    <SmartCard style={{ overflowY: 'auto' }}>
                        <Typography>Contracts</Typography>
                        <SmartTable
                            columns={[{ id: 'name', label: 'Name' }]}
                            noCollapse
                            sticky
                            onClickRow={i => {
                                const contract = counterparty?.contracts[i]
                                const simpleConctract = { id: contract.id, name: contract.name, type: { id: contract.typeId } }
                                dispatch(changeRoute({ route: 'contract-details', params: { contract: simpleConctract }, customRouteName: simpleConctract?.name }))
                            }}
                            // onClickRow={(i) => dispatch(changeRoute({ route: 'contract-details', params: { contractId: response[i].id } }))}
                            datasource={{ rows: counterparty?.contracts?.map((x, i) => SmartTableUtilities.toRow([{ value: x.name }], i)) }}
                        />

                    </SmartCard>
                </Tile.Column>
                <Tile.Column style={{ margin: 10 }}>
                    <SmartCard table={true}>
                        <Typography>Counterparties</Typography>
                        <SmartTable
                            columns={[{ id: 'name', label: 'Name' }]}
                            noCollapse
                            sticky
                            onClickRow={i => {
                                const provider = counterparty?.providers[i]
                                dispatch(changeRoute({
                                    route: 'provider-contracts',
                                    params: { providerId: provider.id },
                                    customRouteName: provider.name
                                }))
                            }}
                            hidePagination
                            datasource={{
                                rows: counterparty?.providers?.map((x, i) =>
                                    SmartTableUtilities.toRow([{ value: x.name }], i)
                                )
                            }}
                        />
                    </SmartCard>
                </Tile.Column>
            </Tile.Row>
        )
    }

    return (
        <Tile.Container>
            <RouteHeader primary='Counterparties Network' />
            <Tile.Column>
                <SmartCard table={true}>
                    <SmartTable
                        columns={[
                            { id: 'action', label: '' },
                            { id: 'name', label: 'Name' },
                            { id: 'nContracts', label: 'N° Contracts' },
                            { id: 'nCounterparties', label: 'N° Counterparties' }
                        ]}
                        isLoading={status === 'loading'}
                        datasource={{
                            rows: filterCounterparties.map((x, i) => {
                                const CounterpartiesNumber = x?.providers?.length ?? 0
                                const contractsNumber = x?.contracts?.length ?? 0

                                return SmartTableUtilities.toRow(
                                    [
                                        { value: x?.name },
                                        { value: contractsNumber },
                                        { value: CounterpartiesNumber }
                                    ],
                                    i,
                                    renderSubContent(x)
                                )
                            })
                        }}
                        hidePagination
                    />
                    <Box className='smart-table-pagination'>
                        <Pagination
                            key={pagination.page}
                            count={Math.ceil(numberCounterpartiesGroups / pagination.batch)}
                            defaultPage={(pagination.page + 1)}
                            color='primary'
                            sx={{ marginTop: 1 }}
                            disabled={isLoading}
                            onChange={(_, value) => setPagination(p => {
                                return { batch: p.batch, page: value - 1 }
                            })}
                        />
                    </Box>
                </SmartCard>
            </Tile.Column>
            <StaleObserver status={status} />
        </Tile.Container>
    )
}
